@layer branded-header {
  .header {
    width: 100%;
    display: flex;
    align-items: center;
    padding: var(--n-scale-400) var(--n-scale-600);
    box-sizing: border-box;
    background-color: var(--n-color-branded-header-bg, transparent);
    color: var(--n-color-branded-header-text, inherit);
  }

  .header[data-layout='LOGO_LEFT_NAV_RIGHT'] {
    flex-direction: row;
    justify-content: space-between;
  }

  .header[data-layout='LOGO_LEFT_NAV_RIGHT'] .logoSlot {
    flex-shrink: 0;
  }

  .header[data-layout='LOGO_LEFT_NAV_RIGHT'] .navSlot {
    display: flex;
    align-items: center;
    gap: var(--n-scale-500);
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .header[data-layout='LOGO_CENTERED'] {
    flex-direction: column;
    justify-content: center;
    gap: var(--n-scale-400);
  }

  .header[data-layout='LOGO_CENTERED'] .logoSlot {
    order: 1;
  }

  .header[data-layout='LOGO_CENTERED'] .navSlot {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--n-scale-500);
    flex-wrap: wrap;
    order: 2;
  }

  .header[data-layout='MINIMAL'] {
    flex-direction: row;
    justify-content: flex-start;
  }

  .header[data-layout='MINIMAL'] .navSlot {
    display: none;
  }

  .header[data-layout='INLINE'] {
    flex-direction: row;
    justify-content: flex-start;
    gap: var(--n-scale-600);
  }

  .header[data-layout='INLINE'] .navSlot {
    display: flex;
    align-items: center;
    gap: var(--n-scale-500);
    flex-wrap: wrap;
  }

  .header.fixed {
    position: sticky;
    top: 0;
    z-index: 10;
  }

  .logoLink {
    display: inline-flex;
    align-items: center;
    text-decoration: none;
  }

  .logoImg {
    max-height: 2.5rem;
    width: auto;
    object-fit: contain;
    display: block;
  }

  .navList {
    display: contents;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .navItem {
    display: contents;
  }

  .navLink {
    color: inherit;
    text-decoration: none;
    font-size: var(--n-font-size-200);
    white-space: nowrap;
  }

  .navLink:hover {
    text-decoration: underline;
  }
}
